import { range } from 'lodash';
import { DropdownOption } from '../../grid/utils/optionTransformers';

export const createRangeOptions = (start: number, end: number): DropdownOption<number>[] =>
  range(start, end + 1).map(num => ({
    value: String(num),
    label: String(num),
    data: num,
  }));
